import React from 'react';

const ClockOrangeV2 = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement("rect", { width: "48", height: "48", rx: "24", fill: "#FFD300", fillOpacity: "0.12" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M26.8906 15.45H21.1106C20.7106 15.45 20.3906 15.13 20.3906 14.73C20.3906 14.33 20.7106 14 21.1106 14H26.8906C27.2906 14 27.6106 14.32 27.6106 14.72C27.6106 15.12 27.2906 15.45 26.8906 15.45Z",
      fill: "#FFD300"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M31.97 27H29.03C27.76 27 27 27.76 27 29.03V31.97C27 33.24 27.76 34 29.03 34H31.97C33.24 34 34 33.24 34 31.97V29.03C34 27.76 33.24 27 31.97 27ZM31.69 31.46L30.51 32.14C30.27 32.28 30.03 32.35 29.81 32.35C29.64 32.35 29.49 32.31 29.35 32.23C29.03 32.04 28.85 31.67 28.85 31.18V29.82C28.85 29.33 29.03 28.96 29.35 28.77C29.67 28.58 30.08 28.62 30.51 28.86L31.69 29.54C32.11 29.79 32.35 30.13 32.35 30.5C32.35 30.87 32.12 31.21 31.69 31.46Z",
      fill: "#FFD300"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M25.9981 31.9684V29.0284C25.9981 27.2184 27.2181 25.9984 29.0281 25.9984H31.9681C32.1981 25.9984 32.4181 26.0184 32.6281 26.0584C32.6481 25.8184 32.6681 25.5784 32.6681 25.3284C32.6681 20.5384 28.7781 16.6484 23.9981 16.6484C19.2181 16.6484 15.3281 20.5384 15.3281 25.3284C15.3281 30.1084 19.2181 33.9984 23.9981 33.9984C24.8481 33.9984 25.6581 33.8584 26.4381 33.6384C26.1581 33.1684 25.9981 32.6084 25.9981 31.9684ZM24.7481 24.9984C24.7481 25.4084 24.4081 25.7484 23.9981 25.7484C23.5881 25.7484 23.2481 25.4084 23.2481 24.9984V19.9984C23.2481 19.5884 23.5881 19.2484 23.9981 19.2484C24.4081 19.2484 24.7481 19.5884 24.7481 19.9984V24.9984Z",
      fill: "#FFD300"
    }
  )
);
ClockOrangeV2.displayName = "Icons.ClockOrangeV2";

export { ClockOrangeV2 };
//# sourceMappingURL=ClockOrangeV2.js.map
